import { render } from "./ProjectManagement.vue?vue&type=template&id=6d4fd2a0"
import script from "./ProjectManagement.vue?vue&type=script&lang=js"
export * from "./ProjectManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__